import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

import type { AdminV2CrmUserAccountAccessResponse } from "@/types/adminV2/crmUserAccountAccess";

export interface AccountAccessRequest {
  userId: string;
  body: { reason: string };
}
const invalidatesTags = [
  "AdminV2CrmUsers",
  "AdminV2CrmTimeline",
  "AdminV2AuditLog",
] as const;

/** M64b: permission and all-membership scope are enforced by the producer. */
export const buildAdminV2CrmUserAccountAccessEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  disableAdminV2CrmUser: builder.mutation<
    AdminV2CrmUserAccountAccessResponse,
    AccountAccessRequest
  >({
    query: ({ userId, body }) => ({
      url: `/admin/v2/crm/users/${encodeURIComponent(userId)}/disable`,
      method: "POST",
      data: body,
    }),
    invalidatesTags,
  }),
  restoreAdminV2CrmUser: builder.mutation<
    AdminV2CrmUserAccountAccessResponse,
    AccountAccessRequest
  >({
    query: ({ userId, body }) => ({
      url: `/admin/v2/crm/users/${encodeURIComponent(userId)}/restore`,
      method: "POST",
      data: body,
    }),
    invalidatesTags: (_result, _error, { userId }) => [
      ...invalidatesTags,
      { type: "AdminV2CrmUserInternalNotes", id: `USER:${userId}` },
    ],
  }),
});
